<template>
	<div class="drawtable">
		<transition-group name="conttable"
		                  class="transition"
		                  tag="div"
		                  appear
		                  mode="out-in">
			<div class="row header_table"
			     :key="key">
				<div class="cell"
				     v-for="(item, i) in arrayCh[0]"
				     :value="item"
				     :area="i"
				     :key="i">{{i}}
				</div>
			</div>
			<div class="row"
			     v-for="(el, i) in arrayCh"
			     :key="i"
			     :class="setClass(el)">
				<div class="cell"
				     v-for="(item, i) in el"
				     :value="i"
				     :area="i"
				     @mouseover="handlerShowResultInfo"
				     @mouseout="handlerLeaveResultInfo"
				     :key="i">
					{{item === "" ? "No value" : item}}
				</div>
				<div class="show-result-info"
				     v-if="getNameRequest === 'getBalancerHistory'"
				     @mouseout="handlerLeaveResultInfo"
				     @mouseover="handlerShowResultInfo">
					{{el.result_info === "" ? "No value" : el.result_info}}
				</div>
			</div>
		</transition-group>
	</div>
</template>
<script>
	import { mapGetters, mapActions, mapMutations } from "vuex";

	export default {
		data() {
			return {
				key:            "header_table",
				countArray:     0,
				scroll:         1000,
				arrayCh:        [],
				showResultInfo: false
			};
		},
		mounted() {
			window.onscroll = () => {
				let rrr = document.querySelector(".drawtable");
				if (
					document.documentElement.clientHeight +
					document.documentElement.scrollTop >=
					rrr.scrollHeight + rrr.offsetTop
				) {
					this.setCycle(this.getCycle + 1);
					this.arrayCh.push(...this.getArray);
				}
			};
		},
		updated() {
			let row  = document.querySelector(".row");
			let cant = document.querySelector(".drawtable");
			if (row.children) {
				let width = cant.offsetWidth / row.children.length;
				Array.from(row.children).forEach(el => {
					el.style.width = width + "px";
				});
			}
		},
		beforeDestroy() {
			this.setShowFilter(true);
			window.onscroll = null;
			this.setCycle(0);
			this.deleteArray();
		},
		methods:  {
			...mapActions(["setCycle"]),
			...mapMutations(["deleteArray", "setTotalArray", "setShowFilter"]),
			handlerShowResultInfo(e) {
				if (this.getNameRequest === "getBalancerHistory") {
					if (e.target.getAttribute("class") === "show-result-info") {
						e.target.style.display = "block";
					} else {
						if (e.target.getAttribute("value") === "result_info") {
							e.target.parentNode.lastChild.style.display = "block";
						}
					}
				}
			},
			handlerLeaveResultInfo(e) {
				if (this.getNameRequest === "getBalancerHistory") {
					if (e.target.getAttribute("class") === "show-result-info") {
						e.target.style.display = "none";
					} else {
						if (e.target.getAttribute("value") === "result_info") {
							e.target.parentNode.lastChild.style.display = "none";
						}
					}
				}
			},
			setClass(val) {
				let cl;
				for (let item in val) {
					if (val.hasOwnProperty(item)) {
						switch (val[item]) {
							case "":
								cl = "novalue";
								break;
							case "DENIED: BUGS ERROR-403":
								cl = "bugs_error";
								break;
							case "DENIED: Login or password contains invalid characters":
								cl = "logorpass";
								break;
							case "DENIED: Bad request":
								cl = "badrequest";
								break;
							case "authorize":
								cl = "authorized";
								break;
							case null:
								cl = "null";
								break;
							case "empty_value":
								cl = "emptyvalue";
								break;
						}
					}
				}
				return cl;
			}
		},
		computed: {
			...mapGetters(["getArray", "getCycle", "getNameRequest"])
		},
		watch:    {
			"$store.state.arrayTotal"() {
				this.arrayCh.splice(0, this.arrayCh.length);
				this.arrayCh.push(...this.getArray);
				if (this.getArray.length === 0) {
					this.setShowFilter(true);
				} else {
					this.setShowFilter(false);
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	.drawtable {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		width: 95%;
		max-height: calc(100% - 7rem);
		max-width: 1200px;
		margin-top: 6rem;
		z-index: 50;
		.transition {
			padding-bottom: 8rem;
		}
		div {
			display: table;
			position: relative;
			width: 100%;
			max-width: 1200px;
			
			.row {
				display: table-row;
				background-color: rgba(204, 204, 204, 0.79);
				width: 100%;
				max-width: 1200px;
				position: relative;
				.show-result-info {
					position: absolute;
					width: 300px;
					height: 120px;
					left: calc(100% - 500px);
					z-index: 100000;
					display: none;
					background-color: #fff;
					overflow: auto;
					padding: 7px;
					word-wrap: break-word;
					box-shadow: inset 0 0 5px #ccc;
				}
				.cell {
					margin: 1rem;
					display: table-cell;
					overflow: hidden;
					width: 5rem;
					/*min-width: 7rem;*/
					/*max-width: 10rem;*/
					padding: 5px;
					border-right: 1px solid rgba(31, 118, 66, 0.4);
					border-bottom: 1px solid rgba(31, 118, 66, 0.4);
					white-space: nowrap;
					&:first-child {
						border-left: 1px solid rgba(31, 118, 66, 0.4);
					}
					&[area="result_info"] {
						max-width: 200px;
						min-width: 200px;
					}
					&:hover {
						background-color: #97be9f;
						cursor: default;
					}
				}
				
				.no_value {
					background-color: #ffba78;
				}
			}
			
			.header_table {
				display: table-row;
				width: 100%;
				max-width: 1200px;
				text-align: center;
				font-size: 1.1em;
				font-weight: bold;
				background-color: #90cf1c;
			}
			
			.novalue {
				background-color: #ffd6b3;
			}
			
			.bugs_error {
				background-color: #d38957;
			}
			
			.logorpass {
				background-color: #d3a595;
			}
			
			.badrequest {
				background-color: #ffcaca;
			}
			
			.authorized {
				background-color: #a1ff95;
			}
			
			.null {
				background-color: #f168aa;
			}
			
			.emptyvalue {
				background-color: #ffcaca;
			}
		}
	}
	@media (max-width: 620px) {
		.drawtable {
			margin-top: 10rem;
		}
	}
	.conttable-enter-active {
		transition: all 0.7s ease;
	}
	.conttable-leave-active {
		transition: all 0.7s ease;
	}
	.conttable-enter,
	.conttable-leave-to {
		opacity: 0;
	}
	.conttable-move {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue